import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const skeletonVariants = cva(
  'block animate-pulse bg-gray-200 motion-reduce:animate-none dark:bg-gray-700',
  {
    variants: {
      shape: {
        rect: 'rounded-md',
        circle: 'rounded-full',
        text: 'h-4 rounded',
      },
    },
    defaultVariants: { shape: 'rect' },
  }
)

export interface SkeletonProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {
  width?: number | string
  height?: number | string
}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, shape, width, height, style, ...rest }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-label="Carregando"
      aria-live="polite"
      className={cn(skeletonVariants({ shape, className }))}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        ...style,
      }}
      {...rest}
    />
  )
)

Skeleton.displayName = 'Skeleton'

export { skeletonVariants }
